// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"20f2fc4a","247":"dd036db6","284":"ff9e02a9","422":"041076aa","627":"7d2ef332","768":"569bdbb5","806":"dcc3e638","834":"1a1f7227","923":"d6110307","938":"8376b549"}[chunkId] + ".chunk.js";
};